import { gql } from '@apollo/client';

// carrierCode 必填：按尾程商过滤；GA/SCF 场景合并 TEMU_HANDOVER(3) 中相同尾程商的站点
// 调用方需保证 carrier 已选定，未选时应 skip 该查询
//
// warehouseId 可选：传入时后端按该仓的测试属性过滤站点（测试仓只返回测试站点、真实仓只返回真实站点），
// 不传则返回全部。external_station 由 TMS 维护，三种 station_type 线上各有一套测试数据，
// 因此**创建包牌选目的地必须传 warehouseId**，否则会拿到另一套数据体系的段码；
// 包牌列表筛选等无需区分的场景可不传。
export const GET_EXTERNAL_STATION_SORTING_CODES = gql`
    query GetExternalStationSortingCodes($stationType: Int!, $carrierCode: Int!, $warehouseId: Long) {
        getExternalStationSortingCodes(stationType: $stationType, carrierCode: $carrierCode, warehouseId: $warehouseId)
    }
`;

export interface GetExternalStationSortingCodesResponse {
    getExternalStationSortingCodes: string[];
}
